import type {ReactElement} from 'react';
import {MODALS_IDS} from '@Components/modal-container';
import {Modal} from '@Components/modal';
import {LazyPanel} from '@Components/lazy-panel';
import {useModalData} from '@Components/modal/hooks/useModalData';
import {CheckoutHostProvider} from '@Components/checkout-flow/components/checkout-host-provider/checkout-host-provider';
import {useCheckoutModalDimensions} from '@Components/checkout-flow/checkout-flow.hooks';
import {RESUBSCRIBE_CONFIRMATION_MODAL_DIMENSIONS} from '@Modals/resubscribe-confirmation-modal/resubscribe-confirmation-modal.types';

export default function ResubscribeConfirmationModal(): ReactElement {
  const modalId = MODALS_IDS.RESUBSCRIBE_CONFIRMATION_MODAL;
  const panelId = `${modalId}-panel`;
  const {width, height} = useCheckoutModalDimensions(RESUBSCRIBE_CONFIRMATION_MODAL_DIMENSIONS);
  const modalData = useModalData(modalId);

  return (
    <Modal modalId={modalId} panelId={panelId} modalHeight={height} modalWidth={width}>
      <CheckoutHostProvider modalId={modalId} panelId={panelId}>
        <LazyPanel panelDirectoryName="resubscribe-confirmation-panel" panelProps={{...modalData.panelProps, panelId}} />
      </CheckoutHostProvider>
    </Modal>
  );
}
